export const getFetchWithTimeout =
    (timeout: number) =>
    async (input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> => {
        init.signal = AbortSignal.timeout(timeout);
        return await fetch(input, init);
    };
